import localForage from 'localforage'

const reduxStorage = localForage.createInstance({
  name: 'MAN-App-Redux',
  storeName: 'redux_storage'
})

const apolloStorage = localForage.createInstance({
  name: 'MAN-App-Apollo',
  storeName: 'apollo_storage'
})

const schemaStorage = localForage.createInstance({
  name: 'MAN-App-Schema',
  storeName: 'schema_storage'
})

export { reduxStorage, apolloStorage, schemaStorage }



// WEBPACK FOOTER //
// ./src/storage.js